
import { all } from "redux-saga/effects";
import loginAction from './otp'
import logoutAction from './logout'
import fetchHomeFeed from './fetchHomeFeed'
import fetchWalletTxns from './fetchWalletTxns'

export default function* root() {
	yield all([
		loginAction(),
		logoutAction(),
		fetchHomeFeed(),
		fetchWalletTxns(),
	]);
}
